import { LabelText, ValueText } from 'modals/ShiftModal/src/views/DetailView/DetailView.styled';
import { Flex } from 'components/Flex';
import { FC } from 'react';

import {
  formatTime,
  formatUnpaidBreakTime,
} from 'modals/ShiftModal/src/views/DetailView/TimesheetsTab/TimesheetsTab.utils';

import { MountTransition } from 'routes';
import { useTranslation } from 'hooks/useTranslation';
import { DetailViewInnerHeader } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailTabView/DetailTabView';
import { IGeneralTabProps } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/GeneralTab/GeneralTab.types';
import { Order } from 'types/graphql';

export const shiftModalGeneralTabValueTextMarginLeft = 16;
export const shiftModalGeneralTabFormItemVerticalMargin = 24;

export const GeneralTab: FC<IGeneralTabProps> = ({ data }): JSX.Element => {
  const { t } = useTranslation();
  const order = undefined as unknown as Order;

  return (
    <Flex flexDirection="column" childMarginBottom="40px" flex="1">
      <MountTransition>
        <DetailViewInnerHeader data={data} />

        <Flex flexDirection="column" padding="32px" childMarginBottom="32px">
          <Flex>
            <Flex flexDirection="column" width="240px">
              <LabelText>{t('shift_modal:TOTAL_PAID_DURATION')}</LabelText>
              <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                {order!.noShow ? '0 hrs' : formatTime(order!.totalDuration ?? 0)}
              </ValueText>
            </Flex>

            {order!.orderSchedule.breakTime && (
              <Flex flexDirection="column">
                <LabelText>{t('shift_modal:UNPAID_BREAK_TIME')}</LabelText>
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {formatUnpaidBreakTime(order!.orderSchedule.breakTime)}
                </ValueText>
              </Flex>
            )}
          </Flex>

          {order!.community && (
            <Flex flexDirection="column">
              <LabelText>{t('shift_modal:LOCATION')}</LabelText>
              <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                {order!.community.name}
              </ValueText>
              {order!.location && order!.location.fullAddress && (
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {order!.location.fullAddress}
                </ValueText>
              )}
            </Flex>
          )}

          {order!.description && (
            <Flex flexDirection="column">
              <LabelText>{t('shift_modal:SHIFT_NOTES')}</LabelText>
              {order!.description.split('\n').map((textSegment, i, { length }) => (
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {textSegment}
                  {/** Add line break if not first or last text segment */}
                  {i > 0 && i < length - 1 && <br />}
                </ValueText>
              ))}
            </Flex>
          )}
        </Flex>
      </MountTransition>
    </Flex>
  );
};
